/*
 *
 * LeadsPage reducer
 *
 */

import {
  DOWNLOAD_LEADS_REQUEST,
  DOWNLOAD_LEADS_SUCCESS,
  DOWNLOAD_LEADS_FAIL,
  FETCH_LEADS_REQUEST,
  FETCH_LEADS_SUCCESS,
  FETCH_LEADS_FAIL,
} from './constants';
import { toNumber } from 'utils/helpers'

const initialState = {
  fetching: false,
  // Whether the leads request has SETTLED, either way. `fetching` cannot
  // answer that — it is false both before the first request is dispatched and
  // after one comes back — which left the initial render claiming the account
  // has no leads before anyone had asked. Set on success and failure alike.
  loaded: false,
  // Why the last leads fetch failed, or null. Kept OFF the shared `errors`
  // because DOWNLOAD_LEADS_FAIL writes that too, and a failed CSV export must
  // not blank the table it was exporting. Cleared by FETCH_LEADS_SUCCESS and
  // nothing else — see the ChannelsPage reducer for why not on REQUEST.
  listError: null,
  // True when rails refused the fetch because the plan lacks lead capture
  // (403 feature_not_available). The list shows the upgrade prompt; it is not
  // a load failure and never an auth failure.
  upgradeRequired: false,
  downloading: false,
  allLeads: {},
  paging: {},
  errors: null,
};

function leadsPageReducer(state = initialState, action) {
  switch (action.type) {
    case DOWNLOAD_LEADS_REQUEST:
      return {
        ...state,
        downloading: true,
      };
    case DOWNLOAD_LEADS_SUCCESS:
      // The success toast lives in downloadLeadsSuccessFlow (sagas.js), which
      // watches this action type — this reducer stays a pure state update.
      return {
        ...state,
        downloading: false,
      };
    case DOWNLOAD_LEADS_FAIL:
      return {
        ...state,
        downloading: false,
        errors: action.errors,
      };
    case FETCH_LEADS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case FETCH_LEADS_SUCCESS:
      return {
        ...state,
        loaded: true,
        listError: null,
        upgradeRequired: false,
        allLeads: action.data,
        paging: {
          currentPage: toNumber(action.current_page),
          rowsPerPage: toNumber(action.rows_per_page),
          pageCount: toNumber(action.page_count),
        },
        fetching: false,
      };
    // `fetchLeadFail` destructures `errors` off an Error, which carries none,
    // so `action.errors` is normally undefined. The list still has to be able
    // to say the fetch failed, so fall back to a message rather than storing a
    // falsy value the renderer would read as "no failure".
    case FETCH_LEADS_FAIL:
      if (action.statusCode === 403 && action.errorCode === 'feature_not_available') {
        return { ...state, fetching: false, loaded: true, upgradeRequired: true };
      }
      return {
        ...state,
        fetching: false,
        loaded: true,
        // The latest failure decides what the page shows: a stale denial must
        // not hide a later load error and its retry button.
        upgradeRequired: false,
        errors: action.errors,
        listError: action.errors || 'Something went wrong',
      };
    default:
      return state;
  }
}

export default leadsPageReducer;
